import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let range = useDataValue({
    context: 'ranges',
    path: 'date_range',
    viewPath: props.viewPath,
  })

  return <View {...props} onSave={() => props.onChange(range)} />
}
